import request from '@/http/request'
import { createCachedApi } from '@/utils/apiCache'

// 参考数据缓存 TTL：10 分钟
var REF_TTL = 10 * 60 * 1000

/**
 * 产品查询接口（用户相关，不缓存）
 */
export function getProductList(params){
    return request({
        url:'/system/product/list',
        method:'get',
        params,
    })
}

/**
 * 产品筛选类型接口（缓存）
 */
export var getProductFilterType = createCachedApi(function(params){
    return request({
        url:'/system/product/filterType',
        method:'get',
        params,
    })
}, REF_TTL, '/system/product/filterType')


/**
 * 家族系列筛选（依赖筛选参数，不缓存）
 */
export const getProductFilter = createCachedApi(function(data) {
    return request({
        url:'/system/categories/filter',
        method:'post',
        data:data
    })
}, 0, '/system/categories/filter')

/**
 * 产品分类查询接口（缓存）
 */
export var getProductType = createCachedApi(function(params){
    return request({
        url:'/system/categories/list',
        method:'get',
        params,
    })
}, REF_TTL, '/system/categories/list')

/**
 * 系列分类查询接口：重新进入页面时获取最新排序。
 */
export const getSeriesCategoryList = createCachedApi(function(params) {
    return request({
        url:'/system/seriesCategory/list',
        method:'get',
        params,
    })
}, 0, '/system/seriesCategory/list')

/**
 * 查询首页轮播配置（缓存）
 */
export var getHomeBanner = createCachedApi(function(){
    return request({
        url:'/system/carousel/list',
        method:'get',
    })
}, REF_TTL, '/system/carousel/list')

/**
 * 查询首页公司轮播配置（缓存）
 */
export var getCompanyBanner = createCachedApi(function(){
    return request({
        url:'/system/companycarousel/list',
        method:'get',
    })
}, REF_TTL, '/system/companycarousel/list')

/**
 * 查询首页视频配置列表（缓存）
 */
export var listVideo = createCachedApi(function() {
    return request({
      url: '/system/video/list',
      method: 'get',
    })
}, REF_TTL, '/system/video/list')

// Series breadcrumb returns must reload the current category membership.
export const getSeriesCategoryProducts = createCachedApi(function(params) {
    return request({ url: '/system/categories/list', method: 'get', params })
}, 0, '/system/categories/list:live')
